import emojibase from 'emojibase-data/en/compact.json';
import { freeze } from '@reduxjs/toolkit';

const emojiData = freeze(
  emojibase.filter((emojiData) => emojiData?.tags?.length > 0),
  true,
);

export default emojiData;
